import { Tooltip } from '@shinetools/lumen-react'
import { forwardRef, ReactElement, Ref, useCallback } from 'react'

import { useIsTruncated } from '../../../../../../../../hooks'
import { SuppliersBalance } from '../../../../../../types/SuppliersBalance'
import { AccountNumber, ItemButton, Label, Separator } from './styles'

interface Props {
  supplier: SuppliersBalance
  isSelected: boolean
  onClick: (supplier: SuppliersBalance) => void
  tabIndex?: number
}

export const SupplierListItem = forwardRef(
  ({ supplier, isSelected, onClick, tabIndex = 0 }: Props, ref: Ref<HTMLButtonElement>): ReactElement => {
    const { auxiliaryAccountNo, name } = supplier
    const handleClick = useCallback(() => onClick(supplier), [onClick, supplier])
    const [nameRef, isTruncated] = useIsTruncated(name)
    const tooltipLabel = auxiliaryAccountNo ? `${auxiliaryAccountNo} | ${name}` : name

    const button = (
      <ItemButton
        ref={ref}
        isSelected={isSelected}
        onClick={handleClick}
        aria-current={isSelected ? 'true' : undefined}
        tabIndex={tabIndex}
      >
        {auxiliaryAccountNo && (
          <>
            <AccountNumber>{auxiliaryAccountNo}</AccountNumber>
            <Separator aria-hidden="true">|</Separator>
          </>
        )}
        <Label ref={nameRef}>{name}</Label>
      </ItemButton>
    )

    return isTruncated ? (
      <Tooltip label={tooltipLabel} placement="top">
        {button}
      </Tooltip>
    ) : (
      button
    )
  },
)

SupplierListItem.displayName = 'SupplierListItem'
